export default [
    {
        // [0]
        key: "name",
        label: app.$i18n.t("Name"),
        visible: true,
    },
    {
        // [1]
        key: "description",
        label: app.$i18n.t("Description"),
        visible: true,
    },
    {
        // [2]
        key: "users",
        label: app.$i18n.t("Users"),
        visible: true,
    },
    {
        // [3]
        key: "status",
        label: app.$i18n.t("Status"),
        visible: true,
    },
    {
        // [4]
        key: "actions",
        label: app.$i18n.t("Actions"),
        visible: true,
    },
]